import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'

import styles from './styles.scss'

import { Flex } from 'reflexbox'

class Collage extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    width: PropTypes.number,
    height: PropTypes.array,
    photos: PropTypes.array,
    layout: PropTypes.array
  }

  constructor(props){
    super(props)
  }

  calcCumulativeLayout = () => {
      const { layout } = this.props
      let val = [0]
      for (let i = 0; i < layout.length - 1; ++i){
        val.push(layout[i] + val[val.length - 1])
      }
      return val
  }

  render (){
    const {
        onClick,
        width,
        height,
        photos,
        layout,
    } = this.props
    const cumulativeLayout = this.calcCumulativeLayout()
    const numNotDisplayed = photos.length - layout.reduce((a, b) => a + b, 0)
    return (
        <div>
            {layout.map((numPhotos, i) => (
                <Flex key={`photoRow${i}`}>
                    {Array(numPhotos).fill().map((x, j) => {
                        const isLast = (i === layout.length - 1) && (j === numPhotos - 1)
                        const morePhotos = numNotDisplayed > 0 && isLast
                        const w = width / numPhotos
                        const h = height[i]
                        const photo = photos[cumulativeLayout[i] + j]
                        const style = {
                            objectFit: `cover`,
                            width: w,
                            height: h,
                            overflow: `hidden`,
                            border: `2px solid transparent`,
                            opacity: morePhotos ? 0.5 : 1
                        }
                        return (
                        <div styleName="container" onClick={onClick.bind(this, photo)} key={`photo${i}_${j}`}>
                            <img src={photo.source} style={style}/>
                            {morePhotos && <div styleName="morePhotoOverlay">{`+${numNotDisplayed}`}</div>}
                        </div>
                    )})}
                </Flex>
            ))}
        </div>
    )
  }
}

export default CSSModules(Collage, styles)
